import clsx from 'clsx';
import { AnimatePresence, motion } from 'motion/react';
import { ArrowUpTrayIcon } from '@heroicons/react/24/outline';

/**
 * Full-bleed overlay rendered on top of `CaraInput` while a file is being
 * dragged over the compose box.
 *
 * The overlay is `pointer-events-none` so dragover/drop events keep landing
 * on the wrapper that owns `useFileDrop` — the overlay is purely a visual
 * affordance. The parent must be `relative` (and ideally `overflow-hidden`)
 * for `inset-0` to anchor correctly.
 */
export const CaraInputDropOverlay = ({ visible }: { visible: boolean }) => {
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          key="cara-input-drop-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.12, ease: 'easeOut' }}
          className={clsx(
            'pointer-events-none absolute inset-0 z-10 rounded-3xl',
            'flex items-center justify-center',
            'bg-neutral-50/95 dark:bg-neutral-900/95 backdrop-blur-[1px]',
            // 'ring-2 ring-neutral-500 ring-inset',
            'border-2 border-dashed border-neutral-400 dark:border-neutral-600'
          )}
        >
          <motion.div
            initial={{ scale: 0.96, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.96, opacity: 0 }}
            transition={{ duration: 0.15, ease: 'easeOut' }}
            className="flex flex-col items-center gap-2 text-neutral-700 dark:text-neutral-300"
          >
            <div className="rounded-full bg-white dark:bg-neutral-800 p-2 shadow-sm ring-1 ring-neutral-500/30">
              <ArrowUpTrayIcon className="size-5" />
            </div>
            <p className="m-0 font-body text-sm font-medium">Drop files to attach</p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
